import { Loader2 } from 'lucide-react';

export function LoadingSpinner({ className = '' }) {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <Loader2 className="w-6 h-6 text-slate-400 animate-spin" />
    </div>
  );
}

export function PageLoadingSpinner() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <Loader2 className="w-6 h-6 text-slate-400 animate-spin" />
    </div>
  );
}

export function SidebarPageLoadingSpinner() {
  return (
    <div className="flex">
      <div className="ml-0 md:ml-64 pt-14 flex-1 flex items-center justify-center min-h-screen">
        <Loader2 className="w-6 h-6 text-slate-400 animate-spin" />
      </div>
    </div>
  );
}

export function InlineLoadingSpinner() {
  return <div className="text-center py-8"><Loader2 className="w-5 h-5 text-slate-400 animate-spin mx-auto" /></div>;
}
